// Import the question mark icon
import { Dropdown } from '_components/Select'
import { TooltipText } from '_components/Text'
import { Globe, Wand } from 'lucide-react'
// import Select from "components/core/Select";
import { useFormContext } from 'react-hook-form'

const languageOptions = [
  { key: 'babel', label: 'Babel (All Languages)', icon: <Globe size={20} /> },
  { key: 'en', label: 'English', iso2: 'us' },
  { key: 'babel-en', label: 'English (Babel)', iso2: 'us' },
  { key: 'en-US', label: 'English (US)', iso2: 'us' },
  { key: 'en-GB', label: 'English (UK)', iso2: 'gb' },
  { key: 'en-AU', label: 'English (Australia)', iso2: 'au' },
  { key: 'en-NZ', label: 'English (New Zealand)', iso2: 'nz' },
  { key: 'en-IN', label: 'English (India)', iso2: 'in' },
  { key: 'es', label: 'Spanish', iso2: 'es' },
  { key: 'babel-es', label: 'Spanish (Babel)', iso2: 'es' },
  { key: 'es-419', label: 'Spanish (Latin America)', iso2: 'mx' },
  { key: 'fr', label: 'French', iso2: 'fr' },
  { key: 'babel-fr', label: 'French (Babel)', iso2: 'fr' },
  { key: 'fr-CA', label: 'French (Canada)', iso2: 'ca' },
  { key: 'de', label: 'German', iso2: 'de' },
  { key: 'babel-de', label: 'German (Babel)', iso2: 'de' },
  { key: 'el', label: 'Greek', iso2: 'gr' },
  { key: 'babel-el', label: 'Greek (Babel)', iso2: 'gr' },
  { key: 'hi', label: 'Hindi', iso2: 'in' },
  { key: 'babel-hi', label: 'Hindi (Babel)', iso2: 'in' },
  { key: 'hi-Latn', label: 'Hindi (Latin script)', iso2: 'in' },
  { key: 'hu', label: 'Hungarian', iso2: 'hu' },
  { key: 'babel-hu', label: 'Hungarian (Babel)', iso2: 'hu' },
  { key: 'ja', label: 'Japanese', iso2: 'jp' },
  { key: 'babel-ja', label: 'Japanese (Babel)', iso2: 'jp' },
  { key: 'ko', label: 'Korean', iso2: 'kr' },
  { key: 'babel-ko', label: 'Korean (Babel)', iso2: 'kr' },
  { key: 'ko-KR', label: 'Korean (Korea)', iso2: 'kr' },
  { key: 'vi', label: 'Vietnamese', iso2: 'vn' },
  { key: 'babel-vi', label: 'Vietnamese (Babel)', iso2: 'vn' },
  { key: 'pt', label: 'Portuguese', iso2: 'pt' },
  { key: 'babel-pt', label: 'Portuguese (Babel)', iso2: 'pt' },
  { key: 'pt-BR', label: 'Portuguese (Brazil)', iso2: 'br' },
  { key: 'pt-PT', label: 'Portuguese (Portugal)', iso2: 'pt' },
  { key: 'zh', label: 'Chinese (Mandarin, Simplified)', iso2: 'cn' },
  { key: 'babel-zh', label: 'Chinese (Babel)', iso2: 'cn' },
  { key: 'zh-CN', label: 'Chinese (Mandarin, Simplified, China)', iso2: 'cn' },
  { key: 'zh-Hans', label: 'Chinese (Mandarin, Simplified, Hans)', iso2: 'cn' },
  { key: 'zh-TW', label: 'Chinese (Mandarin, Traditional)', iso2: 'tw' },
  { key: 'zh-Hant', label: 'Chinese (Mandarin, Traditional, Hant)', iso2: 'tw' },
  { key: 'it', label: 'Italian', iso2: 'it' },
  { key: 'babel-it', label: 'Italian (Babel)', iso2: 'it' },
  { key: 'nl', label: 'Dutch', iso2: 'nl' },
  { key: 'babel-nl', label: 'Dutch (Babel)', iso2: 'nl' },
  { key: 'pl', label: 'Polish', iso2: 'pl' },
  { key: 'babel-pl', label: 'Polish (Babel)', iso2: 'pl' },
  { key: 'ru', label: 'Russian', iso2: 'ru' },
  { key: 'babel-ru', label: 'Russian (Babel)', iso2: 'ru' },
  { key: 'sv', label: 'Swedish', iso2: 'se' },
  { key: 'babel-sv', label: 'Swedish (Babel)', iso2: 'se' },
  { key: 'sv-SE', label: 'Swedish (Sweden)', iso2: 'se' },
  { key: 'da', label: 'Danish', iso2: 'dk' },
  { key: 'babel-da', label: 'Danish (Babel)', iso2: 'dk' },
  { key: 'da-DK', label: 'Danish (Denmark)', iso2: 'dk' },
  { key: 'fi', label: 'Finnish', iso2: 'fi' },
  { key: 'babel-fi', label: 'Finnish (Babel)', iso2: 'fi' },
  { key: 'no', label: 'Norwegian', iso2: 'no' },
  { key: 'babel-no', label: 'Norwegian (Babel)', iso2: 'no' },
  { key: 'id', label: 'Indonesian', iso2: 'id' },
  { key: 'babel-id', label: 'Indonesian (Babel)', iso2: 'id' },
  { key: 'ms', label: 'Malay', iso2: 'my' },
  { key: 'babel-ms', label: 'Malay (Babel)', iso2: 'my' },
  { key: 'tr', label: 'Turkish', iso2: 'tr' },
  { key: 'babel-tr', label: 'Turkish (Babel)', iso2: 'tr' },
  { key: 'uk', label: 'Ukrainian', iso2: 'ua' },
  { key: 'babel-uk', label: 'Ukrainian (Babel)', iso2: 'ua' },
  { key: 'bg', label: 'Bulgarian', iso2: 'bg' },
  { key: 'babel-bg', label: 'Bulgarian (Babel)', iso2: 'bg' },
  { key: 'cs', label: 'Czech', iso2: 'cz' },
  { key: 'babel-cs', label: 'Czech (Babel)', iso2: 'cz' },
  { key: 'ro', label: 'Romanian', iso2: 'ro' },
  { key: 'babel-ro', label: 'Romanian (Babel)', iso2: 'ro' },
  { key: 'sk', label: 'Slovak', iso2: 'sk' },
  { key: 'babel-sk', label: 'Slovak (Babel)', iso2: 'sk' },
  { key: 'babel-ca', label: 'Catalan (Babel)', iso2: 'es' },
  { key: 'babel-ar', label: 'Arabic (Babel)', iso2: 'sa' },
  { key: 'babel-he', label: 'Hebrew (Babel)', iso2: 'il' },
  { key: 'babel-ta', label: 'Tamil (Babel)', iso2: 'in' },
  { key: 'babel-th', label: 'Thai (Babel)', iso2: 'th' },
  { key: 'babel-ur', label: 'Urdu (Babel)', iso2: 'pk' },
  { key: 'babel-hr', label: 'Croatian (Babel)', iso2: 'hr' },
  { key: 'babel-lt', label: 'Lithuanian (Babel)', iso2: 'lt' },
  { key: 'babel-la', label: 'Latin (Babel)', iso2: 'va' },
  { key: 'babel-mi', label: 'Maori (Babel)', iso2: 'nz' },
  { key: 'babel-ml', label: 'Malayalam (Babel)', iso2: 'in' },
  { key: 'babel-cy', label: 'Welsh (Babel)', iso2: 'gb' },
  { key: 'babel-te', label: 'Telugu (Babel)', iso2: 'in' },
  { key: 'babel-fa', label: 'Persian (Babel)', iso2: 'ir' },
  { key: 'babel-lv', label: 'Latvian (Babel)', iso2: 'lv' },
  { key: 'babel-bn', label: 'Bengali (Babel)', iso2: 'bd' },
  { key: 'babel-sr', label: 'Serbian (Babel)', iso2: 'rs' },
  { key: 'babel-az', label: 'Azerbaijani (Babel)', iso2: 'az' },
  { key: 'babel-sl', label: 'Slovenian (Babel)', iso2: 'si' },
  { key: 'babel-kn', label: 'Kannada (Babel)', iso2: 'in' },
  { key: 'babel-et', label: 'Estonian (Babel)', iso2: 'ee' },
  { key: 'babel-mk', label: 'Macedonian (Babel)', iso2: 'mk' },
  { key: 'babel-br', label: 'Breton (Babel)', iso2: 'fr' },
  { key: 'babel-eu', label: 'Basque (Babel)', iso2: 'es' },
  { key: 'babel-is', label: 'Icelandic (Babel)', iso2: 'is' },
  { key: 'babel-hy', label: 'Armenian (Babel)', iso2: 'am' },
  { key: 'babel-ne', label: 'Nepali (Babel)', iso2: 'np' },
  { key: 'babel-mn', label: 'Mongolian (Babel)', iso2: 'mn' },
  { key: 'babel-bs', label: 'Bosnian (Babel)', iso2: 'ba' },
  { key: 'babel-kk', label: 'Kazakh (Babel)', iso2: 'kz' },
  { key: 'babel-sq', label: 'Albanian (Babel)', iso2: 'al' },
  { key: 'babel-sw', label: 'Swahili (Babel)', iso2: 'ke' },
  { key: 'babel-gl', label: 'Galician (Babel)', iso2: 'es' },
  { key: 'babel-mr', label: 'Marathi (Babel)', iso2: 'in' },
  { key: 'babel-pa', label: 'Punjabi (Babel)', iso2: 'in' },
  { key: 'babel-si', label: 'Sinhala (Babel)', iso2: 'lk' },
  { key: 'babel-km', label: 'Khmer (Babel)', iso2: 'kh' },
  { key: 'babel-sn', label: 'Shona (Babel)', iso2: 'zw' },
  { key: 'babel-yo', label: 'Yoruba (Babel)', iso2: 'ng' },
  { key: 'babel-so', label: 'Somali (Babel)', iso2: 'so' },
  { key: 'babel-af', label: 'Afrikaans (Babel)', iso2: 'za' },
  { key: 'babel-oc', label: 'Occitan (Babel)', iso2: 'fr' },
  { key: 'babel-ka', label: 'Georgian (Babel)', iso2: 'ge' },
  { key: 'babel-be', label: 'Belarusian (Babel)', iso2: 'by' },
  { key: 'babel-tg', label: 'Tajik (Babel)', iso2: 'tj' },
  { key: 'babel-sd', label: 'Sindhi (Babel)', iso2: 'pk' },
  { key: 'babel-gu', label: 'Gujarati (Babel)', iso2: 'in' },
  { key: 'babel-am', label: 'Amharic (Babel)', iso2: 'et' },
  { key: 'babel-yi', label: 'Yiddish (Babel)', iso2: 'il' },
  { key: 'babel-lo', label: 'Lao (Babel)', iso2: 'la' },
  { key: 'babel-uz', label: 'Uzbek (Babel)', iso2: 'uz' },
  { key: 'babel-fo', label: 'Faroese (Babel)', iso2: 'fo' },
  { key: 'babel-ht', label: 'Haitian Creole (Babel)', iso2: 'ht' },
  { key: 'babel-ps', label: 'Pashto (Babel)', iso2: 'af' },
  { key: 'babel-tk', label: 'Turkmen (Babel)', iso2: 'tm' },
  { key: 'babel-nn', label: 'Nynorsk (Babel)', iso2: 'no' },
  { key: 'babel-mt', label: 'Maltese (Babel)', iso2: 'mt' },
  { key: 'babel-sa', label: 'Sanskrit (Babel)', iso2: 'in' },
  { key: 'babel-lb', label: 'Luxembourgish (Babel)', iso2: 'lu' },
  { key: 'babel-my', label: 'Myanmar (Babel)', iso2: 'mm' },
  { key: 'babel-bo', label: 'Tibetan (Babel)', iso2: 'cn' },
  { key: 'babel-tl', label: 'Tagalog (Babel)', iso2: 'ph' },
  { key: 'babel-mg', label: 'Malagasy (Babel)', iso2: 'mg' },
  { key: 'babel-as', label: 'Assamese (Babel)', iso2: 'in' },
  { key: 'babel-tt', label: 'Tatar (Babel)', iso2: 'ru' },
  { key: 'babel-haw', label: 'Hawaiian (Babel)', iso2: 'us' },
  { key: 'babel-ln', label: 'Lingala (Babel)', iso2: 'cd' },
  { key: 'babel-ha', label: 'Hausa (Babel)', iso2: 'ng' },
  { key: 'babel-ba', label: 'Bashkir (Babel)', iso2: 'ru' },
  { key: 'babel-jw', label: 'Javanese (Babel)', iso2: 'id' },
  { key: 'babel-su', label: 'Sundanese (Babel)', iso2: 'id' },
  { key: 'babel-yue', label: 'Cantonese (Babel)', iso2: 'hk' },
  { key: 'auto', label: 'Auto Detect (English & Spanish)', icon: <Wand size={20} /> },
]

export default function Language({ fieldName }) {
  const { watch, setValue } = useFormContext()
  const currentLanguage = watch(fieldName)
  const longText = (
    <span>
      Select a supported language of your choice.
      <br />
      {' '}
      Optimizes every part of our API for that language - transcription,
      speech, and other inner workings.
      <br />
    </span>
  )

  return (
    <div style={{}}>
      <div style={{ marginBottom: 5 }}>
        <TooltipText tooltip={longText} tooltipClassName="w-[300px] h-[full]">
          Language
        </TooltipText>
      </div>

      <Dropdown
        options={languageOptions?.map(item => ({
          key: item.key,
          value: item.key,
          label: item.label,
        }))}
        value={currentLanguage}
        onChange={(value) => {
          setValue(fieldName, value.value)
        }}
        placeholder="Select a language..."
        dropdownClass="max-h-[400px]"
      />

      {/* <Select.Root
        value={currentLanguage}
        // fieldName={fieldName}
        onValueChange={(value) => {
          setValue("language", value);
        }}
        size={"3"}
        style={{ width: "100%" }}
      >
        <Select.Trigger
          placeholder="Select a language"
          style={{ width: "100%" }}
        >
          {languageMap[currentLanguage]}
        </Select.Trigger>
        <Select.Content
          position="popper"
          sideOffset={5}
          style={{ width: "100%", maxHeight: 340 }}
          variant="soft"
        >
          {Object.keys(languageMap).map((key) => (
            <Select.Item key={key} value={key}>
              {languageMap[key]}
            </Select.Item>
          ))}
        </Select.Content>
      </Select.Root> */}
    </div>
  )
}
